@if(loading | async) {
    <div class="spinner-container d-flex justify-content-center align-items-center">
        <mat-spinner></mat-spinner>
    </div>
} @else {
    <div class="container mb-5">
        <div class="w-fit">
            <app-back-button routerLink="/bad-guests" component="Bad Guests"></app-back-button>
        </div>
        <div class="d-flex align-items-center mt-3">
            <div class="col-lg-4 col-12">
                <h1>Bad Guest Entry</h1>
            </div>
        </div>
        <div class="row mt-4 mb-5">
            <mat-accordion>
                <app-basic-info-step [basicInformationForm]="basicInformationForm">
                </app-basic-info-step>
                <app-address-step [addressForm]="addressForm" [states]="states" [countries]="countries">
                </app-address-step>
            </mat-accordion>
        </div>
        <div class="mt-2 mb-2 d-flex justify-content-end">
            <button mat-raised-button routerLink="/bad-guests">
                <mat-icon>cancel</mat-icon>
                Cancel
            </button>
            <button mat-raised-button class="action-button submit-bad-guest-button"
                [disabled]="!canCreateBadGuest()" (click)="submitBadGuest()">
                <mat-icon>check</mat-icon>
                Submit Bad Guest
            </button>
        </div>
        @if(!canCreateBadGuest()) {
            <div class="mt-4">
                <mat-action-row class="mt-4 d-flex justify-content-end">
                    <div class="d-flex justify-content-end align-items-center text-muted">
                        <span class="required-input">*</span>&nbsp;- First Name, Last Name and Address required before guest can be created
                    </div>
                </mat-action-row>
            </div>
        }
    </div>
}